<template>
  <div class="mt-5 mb-4">
    <hr class="linha-acoes">

    <div class="d-flex justify-content-end">
      <b-link class="btn btn-voltar mr-3"
              :to="{ name: 'Pendencia'}">
        Voltar para o protocolo
      </b-link>

      <b-link class="btn btn-cadastro"
              :to="rotaCadastro">
        Cadastrar registro
      </b-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AcoesSolicitacao',
    props: {
      tipoRegistro: {
        type: String,
        required: false,
        default: null
      }
    },
    computed: {
      rotaCadastro () {
        if (this.tipoRegistro === 'nascimento') {
          return {
            name: 'cadastro_nascimento',
            params: { idNasc: 'novo' },
            query: { origem: 'arquivos-estruturados' }
          }
        }

        if (this.tipoRegistro === 'óbito') {
          return {
            name: 'cadastro_obito',
            query: { origem: 'arquivos-estruturados' }
          }
        }

        return null
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.linha-acoes {
  border: 0;
  border-top: 1.5px solid #074F7F;
  opacity: 1;
}

.btn-voltar {
  background-color: #C6C6C6;
  border-color: #C6C6C6;
  color: #000000;
}

.btn-voltar:hover {
  background-color: #adadad;
  border-color: #adadad;
}

.btn-cadastro {
  background-color: #074F7F;
  border-color: #074F7F;
  color: #fff;
}

.btn-cadastro:hover,
.btn-cadastro:focus {
  background-color: #063d63;
  border-color: #063d63;
  color: #fff;
}

.btn-cadastro:active {
  background-color: #052f4d;
  border-color: #052f4d;
  color: #fff;
}
</style>